import TagManager from 'react-gtm-module'
import { googleTagManagerId } from '../env';

/**
 * Initialize Google Tag Manager
 * Usually called after obtaining GDRP consent
 */
export default function initGtm(): void {

  // only run in production
  const env = process.env.NODE_ENV;
  if (env !== 'production') {
    return;
  }

  // trigger
  if(googleTagManagerId){
    TagManager.initialize({
      gtmId: googleTagManagerId,
    })
  }
}

